/**
 * Global Cart Label Functions
 * Provides cart label refresh functionality on all pages
 * Independent of cart component loading
 */

let CartLabelSingleton = null;

// Lazy load the cart label service when needed
const getCartLabelService = async () => {
  if (!CartLabelSingleton) {
    try {
      const module = await import('./cart-label');
      CartLabelSingleton = module.default;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to load cart label service:', error);
      return null;
    }
  }
  return CartLabelSingleton;
};

// Global function to refresh cart labels (respects cooldown)
window.refreshCartLabels = async (trigger = 'manual') => {
  try {
    const service = await getCartLabelService();
    if (!service) {
      return false;
    }
    return await service.refresh(trigger);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in refreshCartLabels:', error);
    return false;
  }
};

// Global function to force refresh cart labels (ignores cooldown)
window.forceRefreshCartLabels = async (trigger = 'manual') => {
  try {
    const service = await getCartLabelService();
    if (!service) {
      return false;
    }
    return await service.forceRefresh(trigger);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in forceRefreshCartLabels:', error);
    return false;
  }
};

// Global function to clear session flag
window.clearCartLabelSession = async () => {
  try {
    const service = await getCartLabelService();
    if (!service) {
      return;
    }
    service.clearSessionFlag();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in clearCartLabelSession:', error);
  }
};

// Debug function to check service status
window.debugCartLabelService = async () => {
  try {
    const service = await getCartLabelService();
    if (!service) {
      // eslint-disable-next-line no-console
      console.log('Cart label service: NOT LOADED');
      return undefined;
    }

    // eslint-disable-next-line no-console
    console.log('Cart label service: LOADED');
    // eslint-disable-next-line no-console
    console.log('Last refresh:', new Date(service.lastRefresh));
    // eslint-disable-next-line no-console
    console.log('Cooldown period:', service.refreshCooldown / 1000, 'seconds');
    // eslint-disable-next-line no-console
    console.log(
      'Session refreshed:',
      !!sessionStorage.getItem(service.sessionRefreshKey),
    );

    return service;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking cart label service:', error);
    return undefined;
  }
};

// Make service available globally when loaded
window.getCartLabelService = getCartLabelService;
